<app-christmas-decoration *ngIf="router.url !== '/login' && router.url !== '/logout' && router.url !== '/'"></app-christmas-decoration>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
<app-chatbot *ngIf="showGiaFab"></app-chatbot>
